/** @fileoverview Skeleton shown while the curriculum report is loading. */

import { Skeleton, Stack } from '@mantine/core'

const ROWS = 5

export function DevelopmentReportLoading() {
  return (
    <Stack spacing='sm'>
      {Array.from({ length: ROWS }).map((_, index) => (
        <Skeleton key={index} height={64} radius='md' />
      ))}
    </Stack>
  )
}
